import * as theme from './theme';

export { theme };
